if (!customElements.get('mz-edit-tabs')) {
  customElements.define('mz-edit-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const list = this.querySelector('[data-mz-tabs]');
      const tabs = [...this.querySelectorAll('[data-mz-tab]')];
      const panels = [...this.querySelectorAll('[data-mz-panel]')];
      if (!list || !tabs.length) return;
      list.hidden = false;
      list.setAttribute('role', 'tablist');
      const activate = (index, focus = false) => {
        tabs.forEach((tab, i) => {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', String(index === i));
          tab.tabIndex = index === i ? 0 : -1;
          panels[i].hidden = index !== i;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].tabIndex = 0;
        });
        if (focus) tabs[index].focus();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          activate(next, true);
        });
      });
      activate(0);
    }
  });
}
